// MaterialStock.jsx - Refactored Version
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import * as actions from '../../redux/actions';
import { Error } from '../../components/Error';
import { ViewTitle } from '../../components/ViewTitle';
import {
  OpeningStockTable,
  SalesStockTable,
  PurchaseStockTable,
  BalanceStockTable,
} from '../Material/StockTables';
import dayjs from 'dayjs';

const TABS = [
  { id: 'opening', label: 'คลังยอดยกมา', component: OpeningStockTable },
  { id: 'sales', label: 'คลังยอดขายรวม', component: SalesStockTable },
  { id: 'purchase', label: 'คลังยอดซื้อรวม', component: PurchaseStockTable },
  { id: 'balance', label: 'คลังยอดคงเหลือยกไป', component: BalanceStockTable },
];

function MaterialStock({ title = '', subtitle = '' }) {
  const dispatch = useDispatch();
  const place = useSelector((state) => state.place);
  const material = useSelector((state) => state.material);
  const monthSum = useSelector((state) => state.monthSum);
  const daySum = useSelector((state) => state.daySummary);
  const summary = useSelector((state) => state.gold);
  const [activeTab, setActiveTab] = useState('balance');
  const [page, setPage] = useState();
  const [date, setDate] = useState();
  const [year, setYear] = useState(dayjs().year());
  const [month, setMonth] = useState(dayjs().month() + 1);
  const beforeMonth = dayjs().subtract(1, 'month');
  const thisMonth = dayjs();
  //console.log('daySum', daySum);

  // const filterMonthsa = _.filter(monthSum?.rows, (eachData) => {
  //   if (
  //     dayjs(eachData.month).format('YYYY-MM') === beforeMonth.format('YYYY-MM')
  //   ) {
  //     return eachData;
  //   }
  // });
  // const filterthismonth = _.filter(monthSum?.rows, (eachData) => {
  //   if (
  //     dayjs(eachData.month).format('YYYY-MM') === thisMonth.format('YYYY-MM')
  //   ) {
  //     return eachData;
  //   }
  // });

  const filterSale = summary?.summary?.data?.summaryData?.SALE;
  // console.log('filterSales', filterSales);
  const filterBuy = summary?.summary?.data?.summaryData?.BUY;
  // console.log('filterPurchase', filterBuy);

  // สมมติ daySum.rows คือ array ของข้อมูลแต่ละวัน

  let daySumYesterday = [];
  let yesterday = dayjs().subtract(1, 'day').startOf('day');
  let counter = 0;
  const maxDays = 30;

  while (daySumYesterday.length === 0 && counter < maxDays) {
    daySumYesterday = _.filter(daySum?.rows, (item) =>
      dayjs(item.date).isSame(yesterday, 'day'),
    );

    // ถ้ายังไม่เจอข้อมูล ให้ถอยวันกลับไป และนับจำนวนวันเพิ่ม
    if (daySumYesterday.length === 0) {
      yesterday = yesterday.subtract(1, 'day');
      counter++;
    }
  }

  // ตัวอย่างการส่งให้ OpeningStockTable

  useEffect(() => {
    dispatch(actions.MonthSumAll({ name, page, date: '' }));
    dispatch(actions.getGoldTransactionSummary({ year, month }));
    dispatch(actions.daySummaryAll({ name, page, date: '' }));
    dispatch(actions.materialAll({ name, page, date: '' }));
    return () => {};
  }, []);

  const TabNavigation = () => (
    <div className="bg-white rounded-lg shadow-sm mb-6 overflow-hidden">
      <div className="flex border-b">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`flex-1 px-4 py-3 text-sm font-medium transition-colors ${
              activeTab === tab.id
                ? 'bg-blue-50 text-blue-600 border-b-2 border-blue-600'
                : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );

  const ActiveTabContent = () => {
    const activeTabData = TABS.find((tab) => tab.id === activeTab);
    const ActiveComponent = activeTabData?.component;

    // เลือก data ที่จะส่งให้แต่ละ tab
    let tableData = [];
    if (activeTab === 'opening') {
      tableData = daySumYesterday; // ส่ง filterMonth ให้ OpeningStockTable
    } else if (activeTab === 'sales') {
      tableData = filterSale;
    } else if (activeTab === 'purchase') {
      tableData = filterBuy;
    } else if (activeTab === 'balance') {
      tableData = { material, filterBuy, filterSale };
    }

    return ActiveComponent ? <ActiveComponent data={tableData} /> : null;
  };

  if (place.isCompleted) {
    return (
      <div className="p-6 bg-gray-50 min-h-screen">
        <div className="max-w-7xl mx-auto">
          <div className="mb-6">
            <ViewTitle title={title} subtitle={subtitle} />
          </div>
          <TabNavigation />
          <ActiveTabContent />
        </div>
      </div>
    );
  }

  return <Error message={place?.message} />;
}

MaterialStock.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

export default MaterialStock;
